<template>
  <div class="w-[calc(100%-840px)] absolute bottom-10px z-20 !h-250px  rounded-10px p-10px left-420px bg-[#051A22CC] ">
    <cardTitle title="参建单位投入人数统计" cardType='shimen' />
   <div class="h-[calc(100%-52px)]">
    <div class="content flex">
      <div class="left_cont_per h-full flex items-center">
        <div class="l_cont_date flex">
          <div class="flex items-center b_date">
            <div
              :class="activeDate === 1 ? 'active_date' : ''"
              @click="dateDataBtn(1, '当日')"
              class="fz-16"
            >
              当日
            </div>
            <div
              :class="activeDate === 2 ? 'active_date' : ''"
              @click="dateDataBtn(2, '本周')"
              class="fz-16"
            >
              本周
            </div>
            <div
              :class="activeDate === 3 ? 'active_date' : ''"
              @click="dateDataBtn(3, '本月')"
              class="fz-16"
            >
              本月
            </div>
          </div>
          <div class="total_per flex items-center">
            <div
              class="total_per_cont bottom-[-15px] left-10px"
              :style="{
                backgroundImage: `url(${require('../../assets/image/bg_rstj.png')})`,
              }"
            >
              <div class="date_num">{{ unitInputTotal }}</div>
              <div>[人]</div>
              <div class="toll_cont">{{ dateTitle }}累计投入人数</div>
            </div>
          </div>
        </div>
      </div>
      <div class="h-full py-10px w-[calc(100%-300px)]">
        <UnitCurve
          v-if="showUnitCurve"
          :dateType="dateTitle"
          :unitCurveList="unitCurveList"
        ></UnitCurve>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import CardTitle from '@/components/cockpit/CardTitle'

import CockpitService from '../../service/index'
import UnitCurve from '../charts/UnitCurve.vue'

export default {
  name: '',
  props: [],
  components: { CardTitle, UnitCurve },

  data() {
    return {
      unitCurveList: [],
      activeDate: 1,
      unitInputTotal: 0,
      dateTitle: '当日',
      showUnitCurve: false,
      initInterval: null,
    }
  },
  async created() {
    await this.getDayUnitParticipate()
    this.showUnitCurve = true
    this.initInterval = setInterval(() => {
      if (this.dateTitle === '本周') {
        this.getWeekUnitParticipate()
      } else if (this.dateTitle === '当日') {
        this.getDayUnitParticipate()
      } else {
        this.getMonthUnitParticipate()
      }
    }, 5000)
  },
  beforeDestroy() {
    clearInterval(this.initInterval)
  },
  deactivated() {
    clearInterval(this.initInterval)
  },
  methods: {
    async dateDataBtn(val, type) {
      clearInterval(this.initInterval)
      this.activeDate = val
      this.dateTitle = type
      if (type === '本周') {
        await this.getWeekUnitParticipate()
      } else if (type === '当日') {
        await this.getDayUnitParticipate()
      } else {
        await this.getMonthUnitParticipate()
      }
      this.initInterval = setInterval(() => {
        if (this.dateTitle === '本周') {
          this.getWeekUnitParticipate()
        } else if (this.dateTitle === '当日') {
          this.getDayUnitParticipate()
        } else {
          this.getMonthUnitParticipate()
        }
      }, 5000)
    },
    // 获取参建单位投入人数统计(当天)
    async getDayUnitParticipate() {
      const [err, res] = await CockpitService.getDayUnitParticipate()
      if (res && res.code === 0 && res.data) {
        this.unitInputTotal = res.data.count
        this.unitCurveList = res.data.departmentList
      }
    },
    // 获取参建单位投入人数统计(本周)
    async getWeekUnitParticipate() {
      const [err, res] = await CockpitService.getWeekUnitParticipate()
      if (res && res.code === 0 && res.data) {
        this.unitInputTotal = res.data.count
        this.unitCurveList = res.data.departmentList
      }
    },
    // 获取参建单位投入人数统计(本月)
    async getMonthUnitParticipate() {
      const [err, res] = await CockpitService.getMonthUnitParticipate()
      if (res && res.code === 0 && res.data) {
        this.unitInputTotal = res.data.count
        this.unitCurveList = res.data.departmentList
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.text-white {
  color: #fff;
}
.text-12px {
  font-size: 12px;
}
.text-14px {
  font-size: 14px;
}
.text-16px {
  font-size: 16px;
}

.center-main {

}
.active_date {
  color: #fff;
  font-size: 17px;
  background-image: url('../../assets/image/bg_tab_cjdw.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
}
.content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  .r_title_name {
    color: #ffffff;
    font-size: 18px;
    font-weight: 700;
    span {
      height: 25px;
      display: inline-block;
      width: 5px;
      background: #d9a983;
      border-radius: 3px;
      margin-right: 15px;
    }
  }
  .left_cont_per {
    width: 300px;
    .l_cont_date {
      height: calc(100% - 47px);
      color: rgba(255, 255, 255, 0.6);
      font-size: 16px;
      margin-top: 20px;
      .b_date {
        cursor: pointer;
        flex-direction: column;
        justify-content: space-around;
        div {
          width: 72px;
          height: 30px;
          line-height: 30px;
          text-align: center;
        }
      }
      .total_per {
        flex: 1;
        justify-content: center;
        .total_per_cont {
          // background-image: url('../assets/personImg/bg_rstj.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center 0;
          position: relative;
          text-align: center;
          width: 180px;
          height: 180px;
          color: rgba(255, 255, 255, 0.8);
          display: flex;
          flex-direction: column;
          justify-content: center;
          .date_num {
            font-size: 32px;
          }
        }
      }
    }
  }

}
</style>
